import React from 'react';
import { RxCross2 } from 'react-icons/rx';

export default function ModalPopup({
  children,
  showPopup,
  popupDisplayHandler,
  closeBG = 'cblue-500',
  closeButtonClass = '',
  closeBackgroundColorCode = '',
  maxWidth = '',
  maxHeight = '',
  className,
  showCloseButton = true
}) {
  if (!showPopup) return null;

  return (
    <div
      role="dialog"
      className="z-50 backdrop-blur-sm fixed top-0 left-0 w-full h-full flex items-start justify-center overflow-y-auto py-20">
      <div
        className="absolute z-50 top-0 left-0 w-full h-full"
        onClick={(e) => {
          e.stopPropagation();
          popupDisplayHandler();
        }}
      />
      <div
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[60] bg-white p-6 rounded-lg shadow-xl ${maxWidth} ${maxHeight} ${className}`}>
        {showCloseButton && (
          <button
            data-testid="close-button"
            className={`text-white rounded-full p-2 bg-${closeBG} ${closeButtonClass}`}
            style={{ backgroundColor: closeBackgroundColorCode }}
            onClick={() => {
              popupDisplayHandler();
            }}>
            <RxCross2 />
          </button>
        )}
        <div>{children}</div>
      </div>
    </div>
  );
}
